
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDoctorDashboardData } from '../../../../redux/reducers/doctorDashboardSlice';
function SummaryCards() {
  const dispatch = useDispatch();
  const { activeVetCount, activeOtherCount, totalDoctorsOnHolidayToday, loading, error } = useSelector(
    (state) => state.doctorDashboard
  );

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  if (loading && !activeVetCount) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  const cards = [
    { title: 'Active Vets', value: activeVetCount },
    { title: 'Other Users', value: activeOtherCount },
    { title: 'Absent', value: totalDoctorsOnHolidayToday },
  ];

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card.title}</h4>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 style={{ margin: 0 }}>{card.value}</h2>
            {/* You can re-enable change indicator later */}
            {/* <p
              style={{
                color: card.change.startsWith('+') ? 'green' : 'red',
                margin: 0,
                fontWeight: 'bold',
              }}
            >
              {card.change}
            </p> */}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;